import _ from 'lodash'
import React, { useState } from 'react'
import {
  PreviewSkeletonType
  // SkeletonConfigType
} from 'src/lib/types/uiPreview'
import Pill from './Pill'

interface LoadingListProps {
  length?: number
  skeleton: PreviewSkeletonType
  isHidden: boolean
  isCard: boolean
}

const LoadingDiscountStrip: React.FC<LoadingListProps> = ({ length = 1, skeleton, isHidden, isCard }) => {
  return (
    <>
      {_.times(length, (index: number) => {
        return (
          <div
            key={index}
            style={{
              display: isHidden ? 'none' : 'flex',
              flexDirection: skeleton.layout,
              padding: '1rem',
              width: '100%',
              border: '2px solid #2C874A33',
              borderRadius: '16px',
              gap: 6,
              justifyContent: skeleton?.justify
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: skeleton.layout,
                gap: 6,
                justifyContent: skeleton?.justify
              }}
            >
              {skeleton?.config?.[0]?.config?.map((item: any, index: number) => {
                return <Pill height={item?.height} width={item?.width} key={index} />
              })}
            </div>
            {isCard ? (
              <Pill height={skeleton?.config?.[1]?.height} width={skeleton?.config?.[1].width} key={index} />
            ) : (
              <></>
            )}
          </div>
        )
      })}
    </>
  )
}

export default LoadingDiscountStrip
